














































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from 'oidc-client';
import { PerformoSettings } from 'performo-api';

import VersionInfo from '@/components/system/VersionInformation.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    VersionInfo
  },
  computed: mapGetters({
    settings: 'settings'
  })
})
export default class MainMenu extends Vue {
  private settings!: PerformoSettings;

  @Prop({ required: true, type: Function })
  private logoutHandler!: () => Promise<void>;

  get currentUser(): string {
    return this.$store.getters.userDisplayName;
  }

  get user(): User {
    return this.$store.state.user;
  }

  private userHasInterface(iface: string): boolean {
    if (!this.user.profile) {
      return false;
    } // bail out if we can't read the profile object
    if (Array.isArray(this.user.profile.interface)) {
      return this.user.profile.interface.includes(iface);
    }
    return this.user.profile.interface === iface;
  }

  private userCanDo(canDo: string): boolean {
    if (!this.user.profile) {
      return false;
    } // bail out if we can't read the profile object
    if (Array.isArray(this.user.profile.cando)) {
      return this.user.profile.cando.includes(canDo);
    }
    return this.user.profile.cando === canDo;
  }

  private logout() {
    this.logoutHandler();
  }

  private mounted() {
    // blank
  }
}
